import { useMemo, useState } from 'react'

import { isSelfServeProgram, StoreProgramResponse } from '../../services/storeProgramService'

import { StorefrontModeContextState, StorefrontModeContext, BulkOrderVariantInputState } from '.'

export default function StorefrontModeContextProvider({
  storeProgramResponse,
  children,
  isB2BMode,
}: {
  storeProgramResponse?: StoreProgramResponse
  children: React.ReactNode
  isB2BMode: boolean
}) {
  const [b2bSimilarProductIds, setB2BSimilarProductIds] = useState<string[]>([])
  const [isB2BSimilarProductsLoading, setIsB2BSimilarProductsLoading] = useState(true)
  const [bulkOrderInputStateByVariantId, setBulkOrderInputStateByVariantId] = useState<
    Record<string, BulkOrderVariantInputState>
  >({})
  const [isCustomizationEnabled, setIsCustomizationEnabled] = useState(false)

  const value: StorefrontModeContextState = useMemo(() => {
    const isB2BSelfService = isSelfServeProgram(storeProgramResponse)
    return {
      isB2BMode,
      isB2BSelfService,
      storeProgramResponse,
      b2bSimilarProductIds,
      setB2BSimilarProductIds,
      isB2BSimilarProductsLoading,
      setIsB2BSimilarProductsLoading,
      bulkOrderInputStateByVariantId,
      setBulkOrderInputStateByVariantId,
      isCustomizationEnabled,
      setIsCustomizationEnabled,
    }
  }, [
    storeProgramResponse,
    isB2BMode,
    b2bSimilarProductIds,
    setB2BSimilarProductIds,
    isB2BSimilarProductsLoading,
    setIsB2BSimilarProductsLoading,
    bulkOrderInputStateByVariantId,
    setBulkOrderInputStateByVariantId,
    isCustomizationEnabled,
    setIsCustomizationEnabled,
  ])

  return <StorefrontModeContext.Provider value={value}>{children}</StorefrontModeContext.Provider>
}
